import { apiClient } from "./apiClient";

export interface AdminNotification {
  id: string;
  title: string;
  message: string;
  severity: "info" | "warning" | "error";
  category: string;
  context: Record<string, unknown>;
  createdAt: string;
  readAt: string | null;
  acknowledgedBy: string | null;
  expiresAt: string | null;
}

export interface AdminNotificationsResponse {
  notifications: AdminNotification[];
  count: number;
  refreshedAt: string;
}

export async function fetchAdminNotifications(limit: number = 50): Promise<AdminNotificationsResponse> {
  try {
    // Use apiClient instead of fetch to handle CORS, CSP, and CSRF properly
    const response = await apiClient.get<AdminNotificationsResponse>("/admin/notifications/", {
      params: { limit },
    });
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.detail || error?.message || `Failed to fetch admin notifications: ${error?.response?.status || "Unknown error"}`;
    const newError = new Error(errorMessage) as Error & { statusCode?: number };
    newError.statusCode = error?.response?.status;
    throw newError;
  }
}

export async function acknowledgeNotification(
  notificationId: string,
  acknowledgedBy?: string
): Promise<AdminNotification> {
  try {
    // Use apiClient instead of fetch to handle CORS, CSP, and CSRF properly
    const response = await apiClient.post<AdminNotification>(
      `/admin/notifications/${notificationId}/acknowledge`,
      {
        acknowledgedBy: acknowledgedBy || null,
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.detail || error?.message || `Failed to acknowledge notification: ${error?.response?.status || "Unknown error"}`;
    const newError = new Error(errorMessage) as Error & { statusCode?: number };
    newError.statusCode = error?.response?.status;
    throw newError;
  }
}

